var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品名称",
                            prop: "name",
                            rules: [
                              {
                                required: true,
                                message: "商品名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写商品名称" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "所属类型",
                            prop: "category.id",
                            rules: [
                              {
                                required: true,
                                message: "所属类型不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("SelectTree", {
                            ref: "category",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/test/shop/category/treeData",
                              value: _vm.inputForm.category.id,
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.category.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "价格",
                            prop: "price",
                            rules: [
                              {
                                required: true,
                                message: "价格不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isFloatGtZero,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写价格" },
                            model: {
                              value: _vm.inputForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "price", $$v)
                              },
                              expression: "inputForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注信息",
                            prop: "remarks",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写备注信息",
                            },
                            model: {
                              value: _vm.inputForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "remarks", $$v)
                              },
                              expression: "inputForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }